<template>
  <div>
    <div class="card">
      <div class="card-header">Facility Search</div>
      <div class="card-body">
        <b-row>
          <b-col cols="9">
            <BaseTextInput
                v-model="criteria.name"
                :v="$v.criteria.name"
                label="Facility Name"
                slug="facilityName"
                setId="facilityName"/>
          </b-col>
          <b-col cols="3">
            <BaseMaskedTextInput
              v-model="criteria.hfid"
              :v="$v.criteria.hfid"
              label="HFID"
              slug="hfid"
              setId="hfid"
              mask="#####"
              tip="5 digits"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <BaseTextInput
              v-model="criteria.address"
              :v="$v.criteria.address"
              label="Street Address"
              slug="streetAddress"
              setId="streetAddress"/>
          </b-col>
          <b-col cols="4">
            <BaseTextInput
              v-model="criteria.city"
              :v="$v.criteria.city"
              label="City"
              slug="city"
              setId="city"/>
          </b-col>
          <b-col cols="4">
            <BaseMaskedTextInput
              v-model="criteria.zipCode"
              :v="$v.criteria.zipCode"
              label="Zip Code"
              slug="zipCode"
              setId="zipCode"
              mask="#####"
              tip="5 digits"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <BaseSelector v-model="criteria.type"
              :v="$v.criteria.type"
              slug="facType"
              label="Facility Type"
              setId="facType"
              :options="opts.facilityTypeOptions"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="1">
              <b-button type="button" variant="primary" @click="search">Search</b-button>
          </b-col>
          <b-col cols="1">
              <b-button type="button" variant="secondary" @click="clearSearch">Clear</b-button>
          </b-col>
        </b-row>
        <hr/>
        <div v-if="isSubmitted">
        <b-row>
              <b-table hover small show-empty class="sr-caption" style="width: 100%"
             aria-live="polite"
             responsive="true"
             :fields="fields"
             :items="results"
             :busy="isLoading || isChangingPage"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             caption="Search table.  To sort the data in this table by a specific column,
                                        go to the appropriate column header cell and use enter to sort the data ascending.
                                        Use enter again to sort descending."
             @sort-changed="switchPage($event)"
        >
          <template v-slot:no-data>
            No matching facilities found.
          </template>
          <template v-slot:cell(actions)="row">
            <a class="btn btn-primary" :href="'/viewFacility/'+row.item.id" target="_blank">View</a>
          </template>
        </b-table>
        <b-pagination
              v-if="totalRows>10"
              v-model="criteriaPagination.page"
              :per-page="perPage"
              :total-rows="totalRows"
              align="fill"
              size="sm"
              class="my-0"
              @input="switchPage()"
          ></b-pagination>
        </b-row>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import BaseMaskedTextInput from "@/components/templates/input/BaseMaskedTextInput.vue";
import axios from "axios";

export default {
  name: "FacilitySearch",
  components: {BaseMaskedTextInput, BaseTextInput},
  data: ()=>({
    criteria: {
      name: '',
      address: '',
      city: '',
      zipCode: '',
      // state: '',
      hfid: '',
      type: null,
      page: 1,
      sortBy: null,
      sortDesc: false
    },
    sortBy: 'hfid',
    sortDesc: false,
    results: [],
    totalRows: 1,
    isLoading: false,
    isChangingPage: false,
    isSubmitted: false,
    criteriaPagination: {
      name: '',
      address: '',
      city: '',
      zipCode: '',
      // state: '',
      hfid: '',
      type: null,
      page: 1,
      sortBy: null,
      sortDesc: false
    },
    opts: {
      facilityTypeOptions:[
        {value: null, text: 'Any'},
        {value: "NF", text: 'Nursing Facility'},
        {value: "SNF", text: 'Skilled Nursing Facility'},
        {value: "NH", text: "Nursing Home"},
        {value: "SNFNF", text: "Skilled Nursing Facility/Nursing Facility"},
        {value: "BCH", text: "Board & Care Home"}
      ],
    },
    fields: [
      {key: 'hfid', label:'HFID',sortable: true},
      {key: 'name', label:'Name', sortable: true},
      {key: 'address', label: 'Street Address', sortable: true},
      {key: 'city', label: 'City', sortable: true},
      {key: 'zipCode', label: 'Zip', sortable: true},
      {key: 'type', label: 'Type', sortable: true},
      {key: 'actions', label:'Actions', sortable: false}
    ]
  }),

  methods: {

    search(){
      this.$v.$touch();
      if(this.$v.$error){
        return;
      }
      this.isSubmitted = true;
      this.isLoading = true;
      this.criteria.page=1;
      this.criteria.sortBy=this.sortBy;
      this.criteriaPagination = Object.assign({}, this.criteria);
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/facilitySearch`, this.criteriaPagination)
          .then(response => {
            this.results = response.data.content;
            this.totalRows = response.data.totalElements;
            this.isLoading = false;
            this.isChangingPage = false;
          })

    },
    switchPage($event){
      if($event) {
        this.searchPagination.sortBy = $event.sortBy;
        this.searchPagination.sortDesc = $event.sortDesc;
      }
      this.isChangingPage = true;
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/facilitySearch`, this.criteriaPagination)
          .then(response => {
            this.results = response.data.content;
            this.isLoading = false;
            this.isChangingPage = false;
          })
    },
    clear(){
      this.isSubmitted=false;
      this.isLoading=false;
      this.isChangingPage=false;
      this.criteria={
        name: '',
        address: '',
        city: '',
        zipCode: '',
        // state: '',
        hfid: '',
        type: null,
        page: 1,
        sortBy: null,
        sortDesc: false
      };
      this.criteriaPagination={
        name: '',
        address: '',
        city: '',
        zipCode: '',
        // state: '',
        hfid: '',
        type: null,
        page: 1,
        sortBy: null,
        sortDesc: false
      }
    }
  },

  validations() {
    return{
      criteria: {
        name: {required: false},
        address: {required: false},
        city: {required: false},
        zipCode: {required: false},
        hfid: {required: false},
        type: {required: false},
        includeInactive: {required: false}
      }
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>